// Voyager Energy Partners logo components — original brand assets (transparent PNGs)
const WAVE_PNG = '/vep-wave-white.png';
const FULL_LOGO_PNG = '/vep-logo-white.png';

// Wave-only icon
export const WaveMark = ({ size = 44, className = '' }) => (
  <img
    src={WAVE_PNG}
    alt=""
    width={size}
    height={size}
    className={className}
    style={{ objectFit: 'contain' }}
    aria-hidden="true"
  />
);

// Full original logo (wave + wordmark in original font)
export const Wordmark = ({ compact = false, className = '' }) => (
  <span
    className={`wave-hover inline-flex items-center ${className}`}
    data-testid="brand-logo"
    aria-label="Voyager Energy Partners"
  >
    <img
      src={FULL_LOGO_PNG}
      alt="Voyager Energy Partners"
      className={`wave-img w-auto ${compact ? 'h-12' : 'h-14 lg:h-20'}`}
      style={{ objectFit: 'contain' }}
    />
  </span>
);
